import React from 'react';

import './ErrorMessage.css';

const ErrorMessage = ({ children }) => {
  return <h3 className='error-message'>{children}</h3>;
};

export default ErrorMessage;
